// test583
(583 && 0);
